import {
    MembershipProfileCategory,
    type MembershipProfileNoBookingAnswer,
    QuestionKey,
} from '@fruitful/member-profile';
import { useQueryClient } from '@tanstack/react-query';

import { useAuthedUser } from '../../common/providers/AuthedUserProvider';
import useUpsertMembershipProfileAnswer from '../../member-profile/hooks/useUpsertMembershipProfileAnswer';
import {
    transformDataToMembershipProfileAnswerUpsertDto,
    transformUserToMemberProfileMembership,
} from '../../member-profile/utils/memberProfileUtils';

export const useSaveNoBookingReason = () => {
    const user = useAuthedUser();
    const { mutateAsync: upsertMembershipProfileAnswer } =
        useUpsertMembershipProfileAnswer();
    const queryClient = useQueryClient();

    const saveNoBookingReason = async (value: string) => {
        if (user == null) {
            return;
        }
        const membership = transformUserToMemberProfileMembership(user);
        const answer: MembershipProfileNoBookingAnswer = {
            answer: value,
        };
        const upsertDto = transformDataToMembershipProfileAnswerUpsertDto(
            answer,
            QuestionKey.NO_BOOKING_REASON,
            membership,
            user,
        );
        await upsertMembershipProfileAnswer({ body: [upsertDto] });
        await queryClient.invalidateQueries({
            queryKey: [
                `getMembershipProfileAnswers/${MembershipProfileCategory.NO_BOOKING}`,
            ],
        });
    };

    return {
        saveNoBookingReason,
    };
};
